import { render, staticRenderFns } from "./partnerPreferences.vue?vue&type=template&id=3920607e&scoped=true&v-if=lang%20%26%26%20__(title)&"
import script from "./partnerPreferences.vue?vue&type=script&lang=js&"
export * from "./partnerPreferences.vue?vue&type=script&lang=js&"
import style0 from "./partnerPreferences.scss?vue&type=style&index=0&id=3920607e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3920607e",
  null
  
)

export default component.exports